import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { w as waitForAnimation } from './index3.js';
import { d as defineCustomElement$7 } from './button.js';
import { d as defineCustomElement$6 } from './close-button.js';
import { d as defineCustomElement$5 } from './icon.js';
import { d as defineCustomElement$4 } from './loader.js';
import { d as defineCustomElement$3 } from './tooltip.js';
import { d as defineCustomElement$2 } from './tooltip-label.js';

const modalCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;bottom:0;box-sizing:border-box;display:block;font-family:Open Sans;font-size:.875rem;font-weight:400;left:0;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;overflow:auto;position:fixed;right:0;top:0;z-index:var(--jw-z-index-overlays)}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host .container{align-items:center;bottom:0;display:flex;justify-content:center;left:0;min-height:100%;pointer-events:none;position:relative;right:0;top:0;z-index:var(--jw-z-index-overlays)}:host .backdrop{background-color:#000000b3;bottom:0;left:0;opacity:0;pointer-events:none;position:fixed;right:0;top:0;transition:opacity .25s ease;z-index:calc(var(--jw-z-index-overlays) - 1)}:host .backdrop.-anim-fade-in{animation:fade-in .25s linear forwards;pointer-events:all}@keyframes fade-in{0%{opacity:0}to{opacity:1}}:host .backdrop.-anim-fade-out{animation:fade-out .25s linear forwards}@keyframes fade-out{0%{opacity:1}to{opacity:0}}:host .content{pointer-events:all;z-index:calc(var(--jw-z-index-overlays) + 1)}.container,.content{padding:2rem}.content{background-color:var(--jw-theme-surface-elevated-default-bg-color);border-color:var(--jw-theme-surface-border-border-color);border-radius:.375rem;box-shadow:var(--jw-theme-effects-shadow-shadow-xxl-box-shadow);color:var(--jw-theme-surface-text-default-color);display:flex;flex-direction:column;pointer-events:none;position:relative;transform:scale(0);transition:box-shadow .2s linear .01s}.content.-anim-open{animation:u9s5fwk .5s cubic-bezier(.25,.46,.45,.94) forwards}@keyframes u9s5fwk{0%{opacity:0;transform:scale(.8)}90%{opacity:1}to{transform:scale(1)}}.content.-anim-close{animation:u9s5fy9 .5s cubic-bezier(.25,.46,.45,.94) forwards}@keyframes u9s5fy9{0%{opacity:1;transform:scale(1)}90%{opacity:0}to{opacity:0;transform:scale(.8)}}.content.-anim-minimize{animation:u9s5fz8 .5s cubic-bezier(.23,1,.32,1) forwards}@keyframes u9s5fz8{0%{opacity:0;transform:translate(-8px,-8px);transform-origin:100% 0}to{opacity:1;transform:translate(0);transform-origin:50% 50%}}.content.-anim-minimize-from-max{animation:u9s5g0e .5s cubic-bezier(.23,1,.32,1) forwards}@keyframes u9s5g0e{0%{transform:scale(1.2)}to{transform:scale(1)}}.content.-anim-maximize{animation:u9s5g0z .5s cubic-bezier(.23,1,.32,1) forwards;overflow:auto}@keyframes u9s5g0z{0%{transform:scale(.8)}to{transform:scale(1)}}header{align-items:center;display:inline-flex;justify-content:flex-end}header h2{color:var(--jw-theme-surface-text-default-color);font-family:Open Sans;font-size:1.25rem;font-weight:400;letter-spacing:-.0008em;line-height:1.75rem;margin:0 auto 0 0;word-break:break-word}header[data-header-visible]{padding-bottom:2rem}.description p{font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;margin:0;max-width:480px;word-break:break-word}.body{display:flex;flex:1;flex-direction:column;gap:1rem}.actions{display:flex;flex:1}:host([size=sm]:not([data-display=mini]):not([data-display=max])) .content{width:var(--jw-container-md)}:host([size=md]:not([data-display=mini]):not([data-display=max])) .content{width:var(--jw-container-xl)}:host([size=lg]:not([data-display=mini]):not([data-display=max])) .content{width:var(--jw-container-2xl)}:host([data-display=open]) .content{pointer-events:all}:host([data-display=max]) .container{padding:0}:host([data-display=max]) .actions,:host([data-display=max]) .body{width:100%}:host([data-display=max]) .actions{flex:0}:host([data-display=max]) .content{border-radius:0;min-height:100vh;min-width:100vw;pointer-events:all}:host([data-display=max]) .content-inner{align-items:center;display:flex;flex-direction:column;flex-grow:1;justify-content:space-between;width:100%}:host([data-display=mini]){pointer-events:none}:host([data-display=mini]) .backdrop{opacity:0;pointer-events:none}:host([data-display=mini]) .content{bottom:1rem;box-shadow:var(--jw-theme-effects-shadow-shadow-lg-box-shadow);flex-direction:row;overflow:hidden;padding:.75rem 1rem;pointer-events:all;position:absolute;right:1rem;transition:min-width .35s ease}:host([data-display=mini]) .content-inner{align-items:center;display:flex;flex-direction:row}:host([data-display=mini]) .body{align-items:center;display:flex;flex:1;flex-direction:row;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.75rem;height:100%;letter-spacing:-.0004em;line-height:1.25rem}:host([data-display=mini]) .actions{align-items:center;border:none;display:flex;gap:.5rem;height:100%;white-space:nowrap}:host(:not([data-display=mini])) .body:last-child{margin-bottom:2rem}:host(:not([data-display=mini])) .actions{margin-top:2rem}::slotted([slot]){display:flex;flex:1;flex-direction:column}::slotted([slot=actions]),::slotted([slot=body-mini]){flex-direction:row}::slotted([slot=actions]){gap:.5rem}::slotted([slot=body-mini]){align-items:center;gap:.75rem;margin-right:.75rem;white-space:nowrap}";
const WuiModalStyle0 = modalCss;

const WuiModal$1 = /*@__PURE__*/ proxyCustomElement(class WuiModal extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.displayChanged = createEvent(this, "displayChanged", 3);
        this.animate = async ({ backdrop, content, }) => {
            const shadowRoot = this.el.shadowRoot;
            if (!shadowRoot) {
                return;
            }
            // Set waiter before toggling animation class
            const promise = Promise.all([
                backdrop ? waitForAnimation(shadowRoot.querySelector('.backdrop')) : Promise.resolve(),
                content ? waitForAnimation(shadowRoot.querySelector('.content')) : Promise.resolve(),
            ]);
            if (backdrop) {
                this.backdropAnimClass = backdrop;
            }
            if (content) {
                this.contentAnimClass = content;
            }
            await promise;
        };
        this.handleDismiss = () => {
            // Can't dismiss blocking modals
            if (this.blocking) {
                return;
            }
            switch (this.dismissAction) {
                case 'close':
                    this._setDisplay('closed');
                    break;
                case 'minimize':
                    this._setDisplay('mini');
                    break;
                default:
                    if (this.minimizable) {
                        this._setDisplay('mini');
                    }
                    else {
                        this._setDisplay('closed');
                    }
                    break;
            }
        };
        this.oldOverflow = '';
        this.uid = undefined;
        this.api = undefined;
        this.header = '';
        this.description = '';
        this.theme = 'light';
        this.size = 'sm';
        this.backdrop = true;
        this.minimizable = false;
        this.maximizable = false;
        this.blocking = false;
        this.dismissAction = 'minimizeOrClose';
        this.contentAnimClass = '';
        this.backdropAnimClass = '';
        this.display = 'closed';
    }
    _display(newValue) {
        if (newValue === 'mini') {
            // If display changes to mini, we want the backdrop to scroll
            document.body.style.overflow = this.oldOverflow;
        }
        else {
            document.body.style.overflow = 'hidden';
        }
    }
    /**
     * Set display state.
     *
     * Possible values: `'open'`, `'closed'`, `'mini', 'max'`.
     */
    async setDisplay(value) {
        if (this.display === value) {
            return;
        }
        return this._setDisplay(value);
    }
    _setDisplay(value) {
        return new Promise((resolve) => {
            window.requestAnimationFrame(() => {
                const isMini = this.display === 'mini';
                const isOpen = this.display === 'open';
                const isClosed = this.display === 'closed';
                const isMax = this.display === 'max';
                switch (value) {
                    case 'open':
                        this.resetMiniActionsStyle();
                        this.animate(isClosed || isMini
                            ? {
                                backdrop: '-anim-fade-in',
                                content: '-anim-open',
                            }
                            : isMax
                                ? {
                                    backdrop: '-anim-fade-in',
                                    content: '-anim-minimize-from-max',
                                }
                                : {}).then(() => {
                            this.displayChanged.emit(this.display);
                            resolve();
                        });
                        this.display = 'open';
                        break;
                    case 'max':
                        this.animate({
                            backdrop: undefined,
                            content: '-anim-maximize',
                        }).then(() => {
                            this.displayChanged.emit(this.display);
                            resolve();
                        });
                        this.display = 'max';
                        break;
                    case 'closed':
                        this.animate({
                            backdrop: isMini ? undefined : '-anim-fade-out',
                            content: '-anim-close',
                        }).then(() => {
                            window.requestAnimationFrame(() => {
                                // Wait for animation to finish before persisting value
                                this.display = 'closed';
                                this.displayChanged.emit(this.display);
                                resolve();
                            });
                        });
                        break;
                    case 'mini':
                        this.resetMiniActionsStyle();
                        this.animate({
                            backdrop: isOpen ? '-anim-fade-out' : undefined,
                            content: '-anim-minimize',
                        }).then(() => {
                            this.displayChanged.emit(this.display);
                            resolve();
                        });
                        this.display = value;
                        break;
                    default:
                        resolve();
                        break;
                }
            });
        });
    }
    resetMiniActionsStyle() {
        const shadowRoot = this.el.shadowRoot;
        if (!shadowRoot) {
            return;
        }
        const actionsEl = shadowRoot.querySelector('.actions');
        if (!actionsEl) {
            return;
        }
        actionsEl.style.width = '';
        actionsEl.style.opacity = '';
    }
    connectedCallback() {
        if (this.display !== 'mini') {
            this.oldOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        }
    }
    componentDidLoad() {
        const modalId = this.uid ? `wui_modal__${this.uid}` : '';
        const modal = document.getElementById(modalId);
        modal?.focus();
    }
    disconnectedCallback() {
        document.body.style.overflow = this.oldOverflow;
    }
    render() {
        const { header, description, backdrop, blocking, display, theme, uid, maximizable, minimizable, contentAnimClass, backdropAnimClass, } = this;
        const hasTitle = header && display !== 'mini';
        const isMaximizable = maximizable && display !== 'mini';
        const isMinimizable = minimizable && display !== 'mini';
        const showCloseButton = !blocking && !maximizable && !minimizable && display === 'open';
        return (h(Host, { key: '703e94fb80fdc0e5bb6a3ec453fda7dfa8b3f2a9', id: uid ? `wui_modal__${uid}` : '', "data-display": display, theme: theme, tabIndex: -1 }, backdrop && h("div", { key: '7b2ca272e4febe56142c9e0a522a4218fe7b98f3', class: `backdrop ${backdropAnimClass}`, role: "button", onClick: this.handleDismiss }), h("div", { key: 'e2eb9d0ad845848452c280eb6f2ddc2db80bff97', class: "container" }, h("div", { key: '5005aefc2319743e55f297d77c8b962a5b4226b0', class: `content ${contentAnimClass}` }, h("header", { key: '93cdf195d39d64f8b2ff1c66bbd366c0a63098d9', "data-header-visible": hasTitle || showCloseButton || isMaximizable || isMinimizable }, hasTitle && h("h2", { key: '6ed723000bac5e76a2882eb2f945f6c8c7effec0' }, header), showCloseButton && h("wui-close-button", { key: '3b8389a75bd298956eb58c423c697bef57757e15', onClick: this.handleDismiss }), isMaximizable && (h("wui-button", { key: '5c09a6afba204d74f92d1e4fc4b4b83232a062d7', type: "icon-ghost", icon: display === 'open' ? 'arrows-diagonal' : 'arrows-diagonal-minimize', onClick: () => this.setDisplay(display === 'max' ? 'open' : 'max'), tooltip: display === 'open' ? 'Maximize' : 'Minimize' })), isMinimizable && (h("wui-button", { key: 'bd834463c6b00d2f42dfec8e9017a3f26aae26dd', type: "icon-ghost", icon: "arrows-diagonal-minimize", tooltip: "Minimize", onClick: () => this.setDisplay('mini') }))), h("div", { key: 'f2cb372d2e21dadc80368861f58ff816fb948550', class: "content-inner" }, description && display !== 'mini' && (h("div", { key: '567a831af62203d525bd5c6304f219e7877e9d2c', class: "description" }, description && h("p", { key: '45b68e23836d0ec2e9541a2825ab90f3da4ef90d' }, description))), h("div", { key: '40e44cda44f7137d25f0346ee27d888486d1e2ca', class: "body" }, display === 'mini' ? h("slot", { name: "body-mini" }) : h("slot", { name: "body" })), h("div", { key: 'd1299e5bdb50cb6c8def3fb990779283e187dc72', class: "actions" }, display === 'mini' ? h("slot", { name: "actions-mini" }) : h("slot", { name: "actions" }), !blocking && display === 'mini' && h("wui-close-button", { key: 'aed82b3807929e852d268c1aad2ff6bf33d9a91e', onClick: this.handleDismiss })))))));
    }
    get el() { return this; }
    static get watchers() { return {
        "display": ["_display"]
    }; }
    static get style() { return WuiModalStyle0; }
}, [1, "wui-modal", {
        "uid": [1],
        "api": [16],
        "header": [1],
        "description": [1],
        "theme": [513],
        "size": [513],
        "backdrop": [4],
        "minimizable": [4],
        "maximizable": [4],
        "blocking": [4],
        "dismissAction": [1, "dismiss-action"],
        "contentAnimClass": [32],
        "backdropAnimClass": [32],
        "display": [32],
        "setDisplay": [64]
    }, undefined, {
        "display": ["_display"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-modal", "wui-button", "wui-close-button", "wui-icon", "wui-loader", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-modal":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiModal$1);
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiModal = WuiModal$1;
const defineCustomElement = defineCustomElement$1;

export { WuiModal, defineCustomElement };

//# sourceMappingURL=wui-modal.js.map